import { GridColDef } from "@mui/x-data-grid";
import CustomDataGrid from "../../../components/ui/customDataGrid/customDataGrid.component";
import { useTranslation } from "react-i18next";
import { Business } from "@mui/icons-material";
import { EQUIPMENT_PRODUCERS_ENDPOINT } from "../../../consts";
import { useHasPermission } from "../../../contexts/auth";
import { useNavigate } from "react-router-dom";
import { Box, Chip } from "@mui/material";
import {
  containsStringFilterOperators,
  equalsNumberFilterOperators,
} from "../../../components/ui/customDataGrid/filterOperators";

export default function ProducersList() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const canViewProducers = useHasPermission("settlement.view_equipmentproducer");

  const columns: GridColDef[] = [
    {
      field: "id",
      headerName: "ID",
      filterOperators: equalsNumberFilterOperators(),
    },
    {
      field: "name",
      headerName: t("Name"),
      filterOperators: containsStringFilterOperators(),
      renderCell: (params) => {
        const count = params.row.equipment_count;
        return `${params.row.name} (${count ?? 0})`;
      },
    },
    {
      field: "models",
      headerName: t("Models"),
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const models = params.row.models;
        if (!Array.isArray(models) || models.length === 0) return "—";

        return (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {models.map(
              (
                m: { id?: string | number; name?: string; equipment_count?: number },
                idx: number
              ) => (
                <Chip
                  key={m?.id ?? idx}
                  label={`${m?.name ?? ""} (${m?.equipment_count ?? 0})`}
                  size="small"
                  variant="outlined"
                />
              )
            )}
          </Box>
        );
      },
    },
    {
      field: "modelsCount",
      headerName: t("Model count"),
      sortable: false,
      filterable: false,
      valueGetter: (_value, row) => {
        const models = row.models;
        if (!Array.isArray(models)) return "—";
        return models.length;
      },
    },

  ];

  const handleRowClick = (id: string) => {
    navigate(`/equipment-section/producers/${id}`);
  };

  if (!canViewProducers) {
    return null;
  }

  return (
    <CustomDataGrid
      icon={<Business />}
      title={t("Producers")}
      url={EQUIPMENT_PRODUCERS_ENDPOINT}
      gridSettingsKey="EQUIPMENT_PRODUCERS"
      columns={columns}
      refreshEventName="equipmentProducerAdded"
      onRowClick={handleRowClick}
    />
  );
}
